export const sareeConfig = {
  settings: {
    brand_name: "Surat Saree Factory",
    tagline: "Direct Mill Wholesale Sarees Delivered to Your Doorstep in Ranchi",
    phone: "+91-9204418515",
    whatsapp_number: "919204418515",
    delivery_area: "Ranchi (Same Day) & Jharkhand Express Delivery",
    address: "8th Lane, Sarweshwari Nagar, Bajra, Itki Road, Ranchi, Jharkhand - 834005",
    hero_images: [
      "/assets/sarees/saree-hero-1.jpeg",
      "/assets/sarees/saree-hero-2.jpeg",
      "/assets/sarees/saree-hero-3.jpeg",
      "/assets/sarees/saree-hero-4.jpeg"
    ]
  },
  featured_sarees: [
    {
      id: "surat-featured-1",
      name: "Surat Royal Festive Silk Saree",
      fabric: "Pure Surat Silk with Intricate Zari Weave",
      color: "Rich Festive Palette",
      spec: "5.5m Saree + 0.8m Unstitched Blouse Piece",
      mrp: 5999,
      price: 2199,
      image: "/assets/sarees/saree-hero-1.jpeg",
      badge: "Surat Mill Exclusive"
    },
    {
      id: "surat-featured-2",
      name: "Heritage Traditional Bridal Katan Silk",
      fabric: "Katan Silk with Heavy Jacquard Pallu",
      color: "Grand Occasion Weave",
      spec: "5.5m Saree + 0.8m Brocade Blouse",
      mrp: 6999,
      price: 2599,
      image: "/assets/sarees/saree-hero-2.jpeg",
      badge: "Wedding Special"
    },
    {
      id: "surat-featured-3",
      name: "Designer Floral Embroidered Party Saree",
      fabric: "Premium Georgette Silk with Resham Work",
      color: "Contemporary Festive Hue",
      spec: "5.5m Saree + 0.8m Contrast Blouse",
      mrp: 4499,
      price: 1699,
      image: "/assets/sarees/saree-hero-3.jpeg",
      badge: "Partywear Bestseller"
    },
    {
      id: "surat-featured-4",
      name: "Classic Surat Chanderi Zari Border Saree",
      fabric: "Chanderi Soft Weave with Gold Border",
      color: "Elegant Traditional Tone",
      spec: "5.5m Saree + 0.8m Matching Blouse",
      mrp: 3899,
      price: 1399,
      image: "/assets/sarees/saree-hero-4.jpeg",
      badge: "Festive Collection"
    }
  ],
  categories: [
    {
      id: "banarasi-silk",
      name: "Banarasi & Kanjivaram Silk",
      tagline: "Rich Zari Weaves for Weddings, Pujas & Grand Occasions",
      image: "/assets/sarees/saree-hero-1.jpeg",
      products: [
        {
          id: "royal-banarasi-zari-red",
          name: "Royal Crimson Banarasi Katan Silk Saree",
          fabric: "Pure Katan Silk with Golden Zari Weaving",
          color: "Crimson Red / Gold",
          spec: "5.5m Saree + 0.8m Unstitched Blouse Piece",
          mrp: 6500,
          price: 2499,
          in_stock: true,
          badge: "Wedding Bestseller",
          image: "/assets/sarees/saree-hero-1.jpeg",
          features: ["Intricate Golden Floral Zari Jaal", "Heavy Contrast Rich Zari Pallu", "Direct Surat Loom Weave", "Dry Clean Recommended"]
        },
        {
          id: "kanjivaram-temple-border-royal-blue",
          name: "Heritage Kanjivaram Silk with Temple Border",
          fabric: "Soft Silk with Gold & Silver Zari",
          color: "Royal Blue & Magenta",
          spec: "5.5m Saree + 0.8m Brocade Blouse Piece",
          mrp: 7999,
          price: 2899,
          in_stock: true,
          badge: "Festive Special",
          image: "/assets/sarees/saree-hero-2.jpeg",
          features: ["Authentic Korvai Temple Border", "Double Jacquard Woven Pallu", "Lightweight Pure Soft Silk Feel", "Includes Matching Blouse"]
        },
        {
          id: "banarasi-georgette-rani-pink",
          name: "Banarasi Khaddi Georgette Silk Saree",
          fabric: "Pure Khaddi Georgette Silk",
          color: "Rani Pink with Antique Gold",
          spec: "5.5m Saree + 0.8m Contrast Blouse",
          mrp: 5499,
          price: 2199,
          in_stock: true,
          badge: "Trending Weave",
          image: "/assets/sarees/saree-hero-3.jpeg",
          features: ["Soft Crinkled Flowy Drape", "Handloom Kadwa Zari Booti", "Surat Mill Wholesale Price", "Perfect for Receptions"]
        }
      ]
    },
    {
      id: "georgette-chiffon",
      name: "Surat Georgette & Chiffon",
      tagline: "Lightweight, Elegant Drapes for Daily Wear & Parties",
      image: "/assets/sarees/saree-hero-3.jpeg",
      products: [
        {
          id: "surat-digital-floral-georgette",
          name: "Designer Digital Floral Print Georgette Saree",
          fabric: "60-Gram Pure Surat Georgette",
          color: "Pastel Lavender Floral",
          spec: "5.5m Saree + 0.8m Banglori Silk Blouse",
          mrp: 2499,
          price: 999,
          in_stock: true,
          badge: "Hot Seller",
          image: "/assets/sarees/saree-hero-3.jpeg",
          features: ["Ultra-soft wrinkle-resistant fabric", "High definition digital floral prints", "Gota patti lace border", "Easy hand wash at home"]
        },
        {
          id: "sequin-partywear-chiffon-black",
          name: "Bollywood Style Sequin Work Chiffon Saree",
          fabric: "Pure Viscose Chiffon with Micro Sequins",
          color: "Midnight Black / Silver",
          spec: "5.5m Saree + 0.8m Heavy Satin Blouse",
          mrp: 3899,
          price: 1499,
          in_stock: true,
          badge: "Partywear",
          image: "/assets/sarees/saree-hero-4.jpeg",
          features: ["All-over 3mm tone-to-tone sequin embroidery", "Glamorous evening shine", "Super lightweight drape", "Surat factory direct rate"]
        }
      ]
    },
    {
      id: "cotton-linen",
      name: "Pure Cotton & Linen Weaves",
      tagline: "Breathable, Comfortable & Sophisticated Daily Workwear",
      image: "/assets/sarees/saree-hero-4.jpeg",
      products: [
        {
          id: "chanderi-cotton-handblock",
          name: "Chanderi Cotton Saree with Zari Border",
          fabric: "Cotton Silk Blend (Chanderi Weave)",
          color: "Mustard Yellow & Olive Green",
          spec: "5.5m Saree + 0.8m Cotton Blouse",
          mrp: 2200,
          price: 849,
          in_stock: true,
          badge: "Daily Elegance",
          image: "/assets/sarees/saree-hero-4.jpeg",
          features: ["Traditional handblock motifs", "Thin zari border detailing", "Skin-friendly summer fabric", "Comfortable all-day wear"]
        },
        {
          id: "pure-linen-silver-border",
          name: "Pure Organic Linen Saree with Silver Zari",
          fabric: "100 Count Organic Linen",
          color: "Mint Green & Silver",
          spec: "5.5m Saree + 0.8m Linen Blouse",
          mrp: 3200,
          price: 1299,
          in_stock: true,
          badge: "Premium Organic",
          image: "/assets/sarees/saree-hero-2.jpeg",
          features: ["Eco-friendly breathable pure linen", "Minimalist silver woven pallu", "Formal & office wear choice", "Softens with every wash"]
        }
      ]
    },
    {
      id: "bridal-embroidered",
      name: "Bridal & Heavy Embroidered",
      tagline: "Intricate Cutwork, Resham Embroidery & Mirror Detailing",
      image: "/assets/sarees/saree-hero-2.jpeg",
      products: [
        {
          id: "heavy-bridal-zari-maroon",
          name: "Heavy Bridal Heritage Zardosi Saree",
          fabric: "Heavy Silk Georgette with Resham & Zardosi",
          color: "Bridal Maroon & Antique Gold",
          spec: "5.5m Saree + 1.0m Heavy Embroidered Blouse",
          mrp: 12500,
          price: 4999,
          in_stock: true,
          badge: "Bridal Exclusive",
          image: "/assets/sarees/saree-hero-2.jpeg",
          features: ["Handcrafted Zardosi & Moti work border", "Designer scalloped cutwork edge", "Surat factory direct bridal rate", "Includes full front-back heavy blouse piece"]
        }
      ]
    },
    {
      id: "bandhani-leheriya",
      name: "Bandhani & Leheriya",
      tagline: "Vibrant Gujarati & Rajasthani Tie-Dye Weaves",
      image: "/assets/sarees/saree-hero-1.jpeg",
      products: [
        {
          id: "traditional-surat-bandhani-gharchola",
          name: "Traditional Surat Silk Gharchola Bandhani",
          fabric: "Art Silk with Zari Check & Bandhej Dots",
          color: "Scarlet Red & Golden Yellow",
          spec: "5.5m Saree + 0.8m Bandhani Blouse",
          mrp: 3500,
          price: 1399,
          in_stock: true,
          badge: "Puja Bestseller",
          image: "/assets/sarees/saree-hero-1.jpeg",
          features: ["Authentic Jaipuri/Surat Gharchola zari grids", "Vibrant festive colors", "Auspicious for Chhath, Durga Puja & Haldi", "Direct factory price"]
        }
      ]
    }
  ]
};
